export default __webpack_public_path__ + "static/media/Highlord's Pendant of Fluidity.63c9464e.jpg";